export default __webpack_public_path__ + "static/9f3f3b8dd524b756f73e98d481e02440.png";